import { render, staticRenderFns } from "./quotacostcompute.vue?vue&type=template&id=cb517cb0&scoped=true&"
import script from "./quotacostcompute.vue?vue&type=script&lang=js&"
export * from "./quotacostcompute.vue?vue&type=script&lang=js&"
import style0 from "./quotacostcompute.vue?vue&type=style&index=0&id=cb517cb0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb517cb0",
  null
  
)

export default component.exports